import React from 'react';
import styled from 'styled-components';

import logo from 'images/logo.svg';

interface LogoProps {
  scale: number;
  showText: boolean;
}

interface LogoCharactersProps {
  scale: number;
}

interface LogoTextProps {
  scale: number;
}

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoCharacters = styled.img<LogoCharactersProps>`
  width: ${(props) => `${props.scale * 3}px`};
  height: ${(props) => `${(props.scale / 5) * 7}px`};
`;

const LogoText = styled.div<LogoTextProps>`
  font-family: 'Comfortaa-Bold';
  font-size: ${(props) => `${props.scale / 2}px`};
  color: #1d4ed8;
`;

const Logo: React.FC<LogoProps> = ({ scale, showText }) => {
  return (
    <LogoContainer>
      <LogoCharacters scale={scale} src={logo} />
      {showText ? <LogoText scale={scale}>Sansan Tech</LogoText> : null}
    </LogoContainer>
  );
};

export default Logo;
